import TeRitoBaseSerializer from './base';

export default class Connection extends TeRitoBaseSerializer {}
